
import React, { useState } from 'react'
import Header from '../../headerone/Main'
import Breadcrumb from '../../Breadcrumb/Main'
import Academicleft from './Academicleft'
import { Container, Row, Col, Table } from "react-bootstrap";

// import { Container, Row } from "react-bootstrap";


function Main() {


    const [activeIndex, setActiveIndex] = useState(null);

    const handleToggle = (index) => {
        setActiveIndex((prevIndex) => (prevIndex === index ? null : index));
    };
    const faqData = [

        {
            id: 'heading2',
            question: 'Chemical Engineering - Minor in Green and Renewable Energy',
            answer: `<table class="table table-striped table-bordered" style="width:100%; text-align: left;">  
                    
            <tbody style="line-height: 2.5;">
            <tr>
            <th Colspan="3">Core Courses</th>
            </tr>
            <tr>
            <th>S.No.</th>
            <th>Course Title</th>
            <th>L-T-P-C</th>
            </tr>
            <tr>
            <td>1. </td>
            <td>CH526L Introduction to Renewable Energy</td>
            <td>3-0-0-3</td>
            </tr>
            <tr>
            <td>2.</td>
            <td>HS510L Introduction to Energy and Environmental Policy</td>
            <td>3-0-0-3</td>
            </tr>
            
            <tr classname='text-center'>
            <th Colspan="3">Elective Courses</th>
            </tr>
            <tr>
            <td>3.</td>
            <td>CH520L Engineering Economics and Sustainability </td>
            <td>3-0-0-3</td>
            </tr>
            <tr>
            <td>4. </td>
            <td>CE523M Environmental Risk Assessment</td>
            <td> 1-0-3-3 </td>
            </tr>
            <tr>
            <td>5. </td>
            <td>CH518L Electrochemical Energy Storage</td>
            <td> 3-0-0-3 </td>
            </tr>
            <tr>
            <td>6. </td>
            <td>ME532L Hydrogen Production, Storage, and Safety</td>
            <td>3-0-0-3</td>
            </tr>
            <tr>
            <td>7. </td>
            <td>CE511L Integrated Impact Assessment</td>
            <td>3-0-0-3</td>
            </tr>
            <tr>
            <td>8. </td>
            <td>EE538L Introduction to Smart Grid Technology</td>
            <td>3-0-0-3</td>
            </tr>
            <tr>
            <td>9. </td>
            <td>ME611L Wind Turbine Systems</td>
            <td> 3-0-0-3 </td>
            </tr>
            <tr>
            <td>10. </td>
            <td>HS301L Environmental and Resource Economics</td>
            <td> 3-0-0-3 </td>
            </tr>
            <tr>
            <td>11. </td>
            <td>CH530L Battery Manufacturing Technology</td>
            <td> 3-0-0-3 </td>
            </tr>
            <tr>
            <td>12. </td>
            <td>ME556L Energy Storage Technologies</td>
            <td> 3-0-0-3 </td>
            </tr>

            <tr>
            <td></td>
            <td Rowspan="2"><b>TOTAL CREDITS</b></td>
            
            <td> <b>12</b> </td>
            </tr>

            
            </tbody>
            </table>`,
        },
       
         {
            id: 'headingfift',
            question: 'Chemical Engineering - Minor in Intelligent System Automation',
            answer: `<table class="table table-striped table-bordered" style="width:100%; text-align: left;">            
            <tbody style="line-height: 2.5;">
            <tr>
            <th Colspan="3">Core Courses</th>
            </tr>
            <tr>
            <th>S.No.</th>
            <th>Course Title</th>
            <th>L-T-P-C</th>
            </tr>
            <tr>
            <td>1. </td>
            <td>CH218L Process Dynamics and Control (Or)<br>EE303L Control Engineering (Or)<br>ME312M Linear System Dynamics and Control (Only one of the three)</td>
            <td>3-1-0-4<br>3-1-0-4<br>3-0-2-4</td>
            </tr>
            <tr>
            <td>2.</td>
            <td>CH510L Machine Learning in Process Engineering (Or)<br>ME542L Machine Learning for Mechanical Engineers (Or)<br>EE567L  Machine Learning for Signal Inference (Or) <br> EE506L Pattern Recognition and Machine Learning (Only one of the four)</td>
            <td>3-0-0-3<br>3-0-0-3<br>3-0-0-3<br>3-0-0-3</td>
            </tr>
            
            <tr classname='text-center'>
            <th Colspan="3">Elective Courses</th>
            </tr>
            <tr>
            <td>3.</td>
            <td>CH527L Reinforcement Learning in Process Engineering </td>
            <td>3-0-0-3</td>
            </tr>
            <tr>
            <td>4. </td>
            <td>CH502L Optimization Techniques</td>
            <td> 1-0-3-3 </td>
            </tr>
            <tr>
            <td>5. </td>
            <td>CH525L Optimization for Machine Learning</td>
            <td> 3-0-0-3 </td>
            </tr>
            <tr>
            <td>6. </td>
            <td>CH528L Applied Time Series Analysis</td>
            <td>3-1-0-4</td>
            </tr>
            <tr>
            <td>7. </td>
            <td>EE555L Deep Learning for Computer Vision</td>
            <td>3-0-0-3</td>
            </tr>
            <tr>
            <td>8. </td>
            <td>CH505L Modern Process Control</td>
            <td>3-0-0-3</td>
            </tr>
            <tr>
            <td>9. </td>
            <td>EE505L Optimal Control</td>
            <td> 3-0-0-3 </td>
            </tr>
            <tr>
            <td>10. </td>
            <td>ME523L Robotic Control Systems</td>
            <td> 3-0-0-3 </td>
            </tr>
            <tr>
            <td>11. </td>
            <td>HS520L Supply Chain Management</td>
            <td> 3-0-0-3 </td>
            </tr>
            <tr>
            <td>12. </td>
            <td>HS526L Fundamentals of Business Analytics: Methods and Tools</td>
            <td> 2-1-0-3 </td>
            </tr>
            <tr>
            <td>13. </td>
            <td>CH523L Chemical Production Scheduling</td>
            <td> 3-0-0-3 </td>
            </tr>
            <tr>
            <td>14. </td>
            <td>EE519L Modelling and Control of Cyber-Physical Systems</td>
            <td> 3-0-0-3 </td>
            </tr>
            

            <tr>
            <td></td>
            <td Rowspan="2"><b>TOTAL CREDITS</b></td>
            
            <td> <b>12</b> </td>
            </tr>

            
            </tbody>
            </table>`,
        },
        {
            id: 'heading1',
            question: 'Civil and Environmental Engineering - Minor in Environmental Management',
            answer: `<table class="table table-striped table-bordered" style="width:100%; text-align: left;">            
            <tbody style="line-height: 2.5;">
            <tr>
            <th Colspan="3">Core Courses</th>
            </tr>
            <tr>
            <th>S.No.</th>
            <th>Course Title</th>
            <th>L-T-P-C</th>
            </tr>
            <tr>
            <td>1. </td>
            <td>CE216L: Water and Wastewater Engineering</td>
            <td>2-1-0-3</td>
            </tr>
            <tr>
            <td>2.</td>
            <td>CE3XXL: Solid Waste Management</td>
            <td>2-0-0-2</td>
            </tr>
            <tr>
            <td>3.</td>
            <td>CE3XXP: Environmental Engineering Laboratory</td>
            <td>0-0-3-2</td>
            </tr>
            <tr classname='text-center'>
            <th Colspan="3">Elective Courses</th>
            </tr>
            <tr>
            <td>4. </td>
            <td>CE511L: Integrated Impact Assessment</td>
            <td> 3-0-0-3 </td>
            </tr>
            <tr>
            <td>5. </td>
            <td>CE517L: Air Pollution Control Engineering</td>
            <td> 3-0-0-3 </td>
            </tr>
            <tr>
            <td>6. </td>
            <td>CE525M: GIS and Remote Sensing</td>
            <td>1-0-3-3</td>
            </tr>
            <tr>
            <td>7. </td>
            <td>CH520L: Engineering Economics and Sustainability</td>
            <td>3-0-0-3</td>
            </tr>
            <tr>
            <td>8. </td>
            <td>HS501L: Sustainability Science and Governance</td>
            <td>3-0-0-3</td>
            </tr>
            <tr>
            <td>9. </td>
            <td>HS504L: Biodiversity Conservation and Sustainability</td>
            <td> 3-0-0-3 </td>
            </tr>
            <tr>
            <td>10. </td>
            <td>HS510L: Introduction to Energy and Environmental Policy</td>
            <td> 3-0-0-3 </td>
            </tr>
            <tr>
            <td>11</td>
            <td>CE523M: Environmental Risk Assessment</td>
            <td> 3-0-0-3 </td>
            </tr>
            <tr>
            <td>12</td>
            <td>CE3XXX: Water Resources Engineering</td>
            <td> 3-0-0-3 </td>
            </tr>

            <tr>
            <td></td>
            <td Rowspan="2"><b>TOTAL CREDITS</b></td>
            
            <td> <b>13</b> </td>
            </tr>

            
            </tbody>
            </table>`,
        },
        {
            id: 'headingThree',
            question: 'Computer Science and Engineering - Minor in Artificial Intelligence',
            answer: `<table class="table table-striped table-bordered" style="width:100%; text-align: left;" >   
                     <tbody style="line-height: 2.5;">
            <tr>
            
           		<tr>
            <th Colspan="3">Core Courses</th>
            </tr>
            <tr>
            <th>S.No.</th>
            <th>Course Title</th>
            <th>L-T-P-C</th>
            </tr>
            <tr>
            <td>1</td>
            <td>CS303L Machine Learning</td>
            <td>3-0-0-3</td>
            </tr>
            <tr>
            <td>2</td>
            <td>CS307L Artificial Intelligence</td>
            <td>3-0-0-3</td>
            </tr>
			 <tr classname='text-center'>
            <th Colspan="3">Elective Courses</th>
            </tr>
            <tr>
            <td>3</td>
            <td>CS533L Reinforcement Learning Algorithms</td>
            <td>3-0-0-3</td>
            </tr>
			<tr>
             <td>4</td>
            <td>CS524L Algorithms for Big Data</td>
            <td>3-0-0-3</td>
            </tr>
            <tr>
            <td>5</td>
            <td>CS534L Foundations of Data Science</td>
            <td>3-0-0-3</td>
            </tr>
            <tr>
            <td>6</td>
            <td>CS515L Computational Methods in Optimization</td>
            <td>3-0-0-3</td>
            </tr>
            <tr>
            <td>7</td>
            <td>CS518L Deep Learning</td>
            <td>3-0-0-3</td>
            </tr>
            <tr>
            <td>8</td>
            <td>CS532L Probabilistic Machine Learning</td>
            <td>3-0-0-3</td>
            </tr>
            <tr>
            <td>9</td>
            <td>CS541L Generative Software Engineering</td>
            <td>3-0-0-3</td>
            </tr>
            <tr>
            <td>10</td>
            <td>CS511L Artificial Neural Networks</td>
            <td>3-0-0-3</td>
            </tr>
            <tr>
            <td>11</td>
            <td>CS521L Stochastic Decision Processes</td>
            <td>3-0-0-3</td>
            </tr>
            <tr>
            <td>12</td>
            <td>CS535L Data Science for Networks</td>
            <td>3-0-0-3</td>
            </tr>
			<tr>
            <td>13</td>
            <td>CS601L Big Data Systems</td>
            <td>3-0-0-3</td>
            </tr>
			<tr>
            <td>14</td>
            <td>CS603L Principles of Reinforcement Learning</td>
            <td>3-0-0-3</td>
            </tr>
			<tr>
            <td>15</td>
            <td>CS604L Stochastic Dynamic Programming and Social Learning</td>
            <td>3-0-0-3</td>
            </tr>
			<tr>
            <td>16</td>
            <td>EE507L Computer Vision</td>
            <td>3-0-0-3</td>
            </tr>
			<tr>
            <td>17</td>
            <td>EE525L Probabilistic Graphical Models</td>
            <td>3-0-0-3</td>
            </tr>

            <tr>
            <td></td>
            <td Rowspan="2"><b>TOTAL CREDITS</b></td>
            
            <td> <b>12</b> </td>
            </tr>

            
            </tbody>
                    </table>`,
        },
        {
            id: 'headingFive',
            question: 'Electrical Engineering - Minor in Communication Technologies',
            answer: `<table class="table table-striped table-bordered" style="width:100%; text-align: left;" >   
                     <tbody style="line-height: 2.5;">
            <tr>
            
           		<tr>
            <th Colspan="3">Core Courses</th>
            </tr>
            <tr>
            <th>S.No.</th>
            <th>Course Title</th>
            <th>L-T-P-C</th>
            </tr>
            <tr>
            <td>1</td>
            <td>MA205L Statistics and Random Processes<br />or<br /> MA204L Probability and Statistics (Substitute course only for 2022 batch B. Tech Students)</td>
            <td>3-0-0-3</td>
            </tr>
            <tr>
            <td>2</td>
            <td>EE211L Communication Systems</td>
            <td>3-0-0-3</td>
            </tr>
			 <tr classname='text-center'>
            <th Colspan="3">Elective Courses</th>
            </tr>
            <tr>
            <td>3</td>
            <td>EE509L Communication Networks</td>
            <td>3-0-0-3</td>
            </tr>
			<tr>
             <td>4</td>
            <td>EE523L Wireless Communication</td>
            <td>3-0-0-3</td>
            </tr>
            <tr>
             <td>5</td>
            <td>EE511L Information Theory and Coding</td>
            <td>3-0-0-3</td>
            </tr>
            <tr>
            <td>6</td>
            <td>EE566L Multiple Antenna Communication for 5G and Beyond</td>
            <td>3-0-0-3</td>
            </tr>
            <tr>
            <td>7</td>
            <td>EE565L Machine Learning for Wireless Communications</td>
            <td>3-0-0-3</td>
            </tr>
            <tr>
            <td>8</td>
            <td>EE563L Quantum Information Theory</td>
            <td>3-0-0-3</td>
            </tr>
            <tr>
            <td></td>
            <td Rowspan="2"><b>TOTAL CREDITS</b></td>
            
            <td> <b>12</b> </td>
            </tr>

            
            </tbody>
                    </table>`,
        },

        {
            id: 'headingSix',
            question: 'Electrical Engineering - Minor in Computational Learning Methods',
            answer: `<table class="table table-striped table-bordered" style="width:100%; text-align: left;" >   
                     <tbody style="line-height: 2.5;">
            <tr>
            
           		<tr>
            <th Colspan="3">Core Courses</th>
            </tr>
            <tr>
            <th>S.No.</th>
            <th>Course Title</th>
            <th>L-T-P-C</th>
            </tr>
            <tr>
            <td>1</td>
            <td>MA205L Statistics and Random Processes <br /><u>Substitute course for 2022 batch B.Tech Students only</u><br />MA204L Probability and Statistics </td>
            <td>3-0-0-3<br /><br />3-0-0-3</td>
            </tr>
            <tr>
            <td>2</td>
            <td>EE567L Machine Learning for Signal Inference</td>
            <td>3-0-0-3</td>
            </tr>
			 <tr classname='text-center'>
            <th Colspan="3">Elective Courses</th>
            </tr>
            <tr>
            <td>3</td>
            <td>EE601L Deep Learning: Theory and Applications</td>
            <td>3-0-0-3</td>
            </tr>
			<tr>
             <td>4</td>
            <td>EE506L Pattern Recognition and Machine Learning</td>
            <td>3-0-0-3</td>
            </tr>
            <tr>
             <td>5</td>
            <td>MA629L Statistical Learning Theory and Applications</td>
            <td>3-0-0-3</td>
            </tr>
            <tr>
            <td>6</td>
            <td>CS533L Reinforcement Learning Algorithms</td>
            <td>3-0-0-3</td>
            </tr>
            <tr>
           <td>7</td>
            <td>CS511L Artificial Neural Networks</td>
            <td>3-0-0-3</td>
            </tr>
            <tr>
            <td>8</td>
            <td>EE555L Deep Learning for Computer Vision</td>
            <td>3-0-0-3</td>
            </tr>
			<tr>
            <td>9</td>
            <td>EE532L Deep Learning for Healthcare</td>
            <td>3-0-0-3</td>
            </tr>
			<tr>
            <td>10</td>
            <td>EE507L Computer Vision</td>
            <td>3-0-0-3</td>
            </tr><tr>
             <td>11</td>
            <td>EE526L Speech Signal Processing</td>
            <td>3-0-0-3</td>
            </tr>
			<tr>
            <td>12</td>
            <td>ME607L Machine Learning in Mechanics</td>
            <td>3-0-0-3</td>
            </tr>
			<tr>
            <td>13</td>
            <td>CH510L Machine Learning in Process Engineering</td>
            <td>3-0-0-3</td>
            </tr>
            <tr>
            <td></td>
            <td Rowspan="2"><b>TOTAL CREDITS</b></td>
            
            <td> <b>12</b> </td>
            </tr>

            
            </tbody>
                    </table>`,
        },

        {
            id: 'headingSeven',
            question: 'Humanities and Social Sciences - Minor in Literature and Language',
            answer: `<table class="table table-striped table-bordered" style="width:100%; text-align: left;" >   
                     <tbody style="line-height: 2.5;">
            <tr>
            
           		<tr>
            <th Colspan="3">Core Courses</th>
            </tr>
            <tr>
            <th>S.No.</th>
            <th>Course Title</th>
            <th>L-T-P-C</th>
            </tr>
            <tr>
             <td>1</td>
            <td>HS310L Modern Literature</td>
            <td>3-0-0-3</td>
            </tr>
            <tr>
             <td>2</td>
            <td>HS302L Indian Literature: Text and Performance</td>
            <td>3-0-0-3</td>
            </tr>
			 <tr classname='text-center'>
            <th Colspan="3">Elective Courses</th>
            </tr>
            <tr>
            <td>3</td>
            <td>HS303L Reading Indian Cinema</td>
            <td>3-0-0-3</td>
            </tr>
			<tr>
             <td>4</td>
            <td>HS201L Introduction to the Science of Language</td>
            <td>3-0-0-3</td>
            </tr>
            <tr>
             <td>5</td>
            <td>HS517L Social Justice and Human Rights</td>
            <td>3-0-0-3</td>
            </tr>
            <tr>
            <td>6</td>
            <td>HS618L Introduction to Migration Studies in Literature</td>
            <td>3-0-0-3</td>
            </tr>
            <tr>
           <td>7</td>
            <td>HS603L Indian Literature in Translation</td>
            <td>3-0-0-3</td>
            </tr>
            <tr>
            <td>8</td>
            <td>HS602L Cultural Studies</td>
            <td>3-0-0-3</td>
            </tr>
			<tr>
            <td>9</td>
            <td>HS626L Gender, Crime, and Popular Media</td>
            <td>3-0-0-3</td>
            </tr>
			<tr>
            <td>10</td>
            <td>HS611L New Media and Digital Culture</td>
            <td>3-0-0-3</td>
            </tr>
            <tr>
             <td>11</td>
            <td>HS604L Indian Poetics</td>
            <td>3-0-0-3</td>
            </tr>
			<tr>
            <td>12</td>
            <td>HS601L Advanced Literary Criticism</td>
            <td>3-0-0-3</td>
            </tr>
			<tr>
            <td>13</td>
            <td>HS617L Conflict Theory</td>
            <td>3-0-0-3</td>
            </tr>
            <tr>
            <td>14</td>
            <td>HS404L Academic Writing</td>
            <td>3-0-0-3</td>
            </tr>
            <tr>
            <td>15</td>
            <td>HS205L English for Communication</td>
            <td>3-0-0-3</td>
            </tr>
            <tr>
            <td></td>
            <td Rowspan="2"><b>TOTAL CREDITS</b></td>
            
            <td> <b>12</b> </td>
            </tr>

            
            </tbody>
                    </table>`,
        },

        {
            id: 'headingEight',
            question: 'Humanities and Social Sciences - Minor in Economics',
            answer: `<table class="table table-striped table-bordered" style="width:100%; text-align: left;" >   
                     <tbody style="line-height: 2.5;">
            <tr>
            
           		<tr>
            <th Colspan="3">Core Courses</th>
            </tr>
            <tr>
            <th>S.No.</th>
            <th>Course Title</th>
            <th>L-T-P-C</th>
            </tr>
            <tr>
             <td>1</td>
            <td>HS309L Principles of Economics</td>
            <td>3-0-0-3</td>
            </tr>
            <tr>
             <td>2</td>
            <td>HS202L International Trade and Finance</td>
            <td>3-0-0-3</td>
            </tr>
			 <tr classname='text-center'>
            <th Colspan="3">Elective Courses</th>
            </tr>
            <tr>
            <td>3</td>
            <td>HS513L Public Finance</td>
            <td>3-0-0-3</td>
            </tr>
			<tr>
             <td>4</td>
            <td>HS510L Introduction to Energy and Environmental Policy</td>
            <td>3-0-0-3</td>
            </tr>
            <tr>
             <td>5</td>
            <td>HS511L Introduction to Program Evaluation</td>
            <td>3-0-0-3</td>
            </tr>
            <tr>
            <td>6</td>
            <td>HS515L Statistical Techniques for Public Policy</td>
            <td>3-0-0-3</td>
            </tr>
            <tr>
           <td>7</td>
            <td>HS508L Economics for Public Policy</td>
            <td>3-0-0-3</td>
            </tr>
            <tr>
            <td>8</td>
            <td>HS203L The Indian Economy</td>
            <td>3-0-0-3</td>
            </tr>
			<tr>
            <td>9</td>
            <td>HS204L Introduction to Political Economy</td>
            <td>3-0-0-3</td>
            </tr>
			<tr>
            <td>10</td>
            <td>HS301L Environmental and Resource Economics</td>
            <td>3-0-0-3</td>
            </tr>
            <tr>
            <td>11</td>
            <td>HS307L Basics of Microeconomics</td>
            <td>3-0-0-3</td>
            </tr>
            <tr>
            <td>12</td>
            <td>HS313L Introduction to Money, Banking and Finance</td>
            <td>3-0-0-3</td>
            </tr>
            <tr>
            <td>13</td>
            <td>HS613L Fundamentals of Econometrics</td>
            <td>3-0-0-3</td>
            </tr>
            <tr>
            <td>14</td>
            <td>HS523M Census and Large-Scale Surveys of India </td>
            <td>1-0-4-3</td>
            </tr>
			
            <tr>
            <td></td>
            <td Rowspan="2"><b>TOTAL CREDITS</b></td>
            
            <td> <b>12</b> </td>
            </tr>

            
            </tbody>
                    </table>`,
        },

        {
            id: 'headingnine',
            question: 'Humanities and Social Sciences - Minor in Management',
            answer: `<table class="table table-striped table-bordered" style="width:100%; text-align: left;" >   
            <tbody style="line-height: 2.5;">
   <tr>
   
          <tr>
   <th Colspan="3">Core Courses</th>
   </tr>
   <tr>
   <th>S.No.</th>
   <th>Course Title</th>
   <th>L-T-P-C</th>
   </tr>
   <tr>
    <td>1</td>
   <td>HS519L Project Management</td>
   <td>3-0-0-3</td>
   </tr>
   <tr>
     <td>2</td>
   <td>HS206L Organizational Behavior</td>
   <td>3-0-0-3</td>
   </tr>
    <tr classname='text-center'>
   <th Colspan="3">Elective Courses</th>
   </tr>
   <tr>
  <td>3</td>
   <td>HS520L Supply Chain Management</td>
   <td>3-0-0-3</td>
   </tr>
   <tr>
    <td>4</td>
   <td>HS306L Leadership and Team Management</td>
   <td>3-0-0-3</td>
   </tr>
   <tr>
    <td>5</td>
   <td>HS514L Public Organization and Management</td>
   <td>3-0-0-3</td>
   </tr>
   <tr>
   <td>6</td>
   <td>HS616L Sustainable Human Resource Management</td>
   <td>3-0-0-3</td>
   </tr>
   <tr>
  <td>7</td>
   <td>ME402L Operations Research</td>
   <td>2-1-0-3</td>
   </tr>
   <tr>
   <td>8</td>
   <td>HS308L Introduction to Financial Management</td>
   <td>3-0-0-3</td>
   </tr>
   <tr>
   <td>9</td>
   <td>HS403L Organizational Psychology: Theory and Practice</td>
   <td>3-0-0-3</td>
   </tr>
   <tr>
    <td>10</td>
   <td>HS502L Financial Statement Analysis</td>
   <td>3-0-0-3</td>
   </tr>
   <tr>
    <td>11</td>
   <td>HS526L Fundamentals of Business Analytics: Methods and Tools</td>
   <td>2-1-0-3</td>
   </tr>
   <tr>
    <td>12</td>
   <td>HS527L Supply Chain Optimization</td>
   <td>2-1-0-3</td>
   </tr>
   
   <tr>
   <td></td>
   <td Rowspan="2"><b>TOTAL CREDITS</b></td>
   
   <td> <b>12</b> </td>
   </tr>

   
   </tbody>
           </table>`,
        },

        {
            id: 'headingten',
            question: 'Humanities and Social Sciences - Minor in Public Policy',
            answer: `<table class="table table-striped table-bordered" style="width:100%; text-align: left;" >   
                     <tbody style="line-height: 2.5;">
            <tr>
            
           		<tr>
            <th Colspan="3">Core Courses</th>
            </tr>
            <tr>
            <th>S.No.</th>
            <th>Course Title</th>
            <th>L-T-P-C</th>
            </tr>
            <tr>
             <td>1</td>
            <td>HS208L Public Policy in India</td>
            <td>3-0-0-3</td>
            </tr>
            <tr>
              <td>2</td>
            <td>HS514L Public Organization and Management</td>
            <td>3-0-0-3</td>
            </tr>
			 <tr classname='text-center'>
            <th Colspan="3">Elective Courses</th>
            </tr>
            <tr>
            <td>3</td>
            <td>HS511L Introduction to Program Evaluation</td>
            <td>3-0-0-3</td>
            </tr>
			<tr>
             <td>4</td>
            <td>HS512L Public Administration, Public Policy &amp; Governance</td>
            <td>3-0-0-3</td>
            </tr>
            <tr>
              <td>5</td>
            <td>HS513L Public Finance</td>
            <td>3-0-0-3</td>
            </tr>
            <tr>
            <td>6</td>
            <td>HS508L Economics for Public Policy</td>
            <td>3-0-0-3</td>
            </tr>
            <tr>
           <td>7</td>
            <td>HS509L Ethics and Public Policy</td>
            <td>3-0-0-3</td>
            </tr>
            <tr>
            <td>8</td>
            <td>HS501L Sustainability Science and Governance</td>
            <td>3-0-0-3</td>
            </tr>
			<tr>
            <td>9</td>
            <td>HS504L Biodiversity Conservation and Sustainability</td>
            <td>3-0-0-3</td>
            </tr>
			<tr>
             <td>10</td>
            <td>HS510L Introduction to Energy and Environmental Policy</td>
            <td>3-0-0-3</td>
            </tr>
			<tr>
             <td>11</td>
            <td>HS616L Sustainable Human Resource Management</td>
            <td>3-0-0-3</td>
            </tr>
            <tr>
             <td>12</td>
            <td>HS523M Census and Large-Scale Surveys of India</td>
            <td>1-0-4-3</td>
            </tr>
            <tr>
             <td>13</td>
            <td>HS312L Cities and Development </td>
            <td>3-0-0-3</td>
            </tr>
            <tr>
             <td>14</td>
            <td>HS521L Urban Transport Economics and Policy</td>
            <td>3-0-0-3</td>
            </tr>
            <tr>
             <td>15</td>
            <td>HS524M Urban Informatics and Spatial Analytics</td>
            <td>2-0-2-3</td>
            </tr>
            <tr>
             <td>16</td>
            <td>HS522L Municipal Finance in India: Theories and Practices</td>
            <td>3-0-0-3</td>
            </tr>
            <tr>
            <td></td>
            <td Rowspan="2"><b>TOTAL CREDITS</b></td>
            
            <td> <b>12</b> </td>
            </tr>

            
            </tbody>
                    </table>`,
        }

        ,

        {
            id: 'headingElven',
            question: 'Mathematics and Statistic - Minor in Statistics',
            answer: `<table class="table table-striped table-bordered" style="width:100%; text-align: left;" >   
                     <tbody style="line-height: 2.5;">
            <tr>
            
           		<tr>
            <th Colspan="3">Core Courses</th>
            </tr>
            <tr>
            <th>S.No.</th>
            <th>Course Title</th>
            <th>L-T-P-C</th>
            </tr>
            <tr>
             <td>1</td>
            <td>MA205L Statistics and Random Processes</td>
            <td>3-0-0-3</td>
            </tr>
            <tr>
             <td>2</td>
            <td>MA508L Statistical Inference (pre-requisite: MA205L)</td>
            <td>3-0-0-3</td>
            </tr>
			 <tr classname='text-center'>
            <th Colspan="3">Elective Courses</th>
            </tr>
            <tr>
            <td>3</td>
            <td>MA519L Sampling Theory (pre-requisite: MA205L)</td>
            <td>2-0-0-2</td>
            </tr>
			<tr>
             <td>4</td>
            <td>MA632L Design of Experiments (pre-requisite: MA508L)</td>
            <td>2-0-0-2</td>
            </tr>
            <tr>
              <td>5</td>
            <td>MA514L Regression Analysis (pre-requisite: MA508L)</td>
            <td>3-1-0-4</td>
            </tr>
            <tr>
            <td>6</td>
            <td>MA634L Time Series Analysis (pre-requisite: MA508L )</td>
            <td>2-0-0-2</td>
            </tr>
            <tr>
           <td>7</td>
            <td>MA603L Multivariate Statistical Analysis (pre-requisite: MA508L)</td>
            <td>3-0-0-3</td>
            </tr>
            <tr>
            <td>8</td>
            <td>MA606L Bayesian Statistics (pre-requisite: MA508L)</td>
            <td>3-0-0-3</td>
            </tr>
			<tr>
            <td>9</td>
            <td>MA610L Non-parametric Statistics (pre-requisite: MA508L)</td>
            <td>3-0-0-3</td>
            </tr>
			<tr>
             <td>10</td>
            <td>MA615L Generalized Linear Models (pre-requisite: MA508L)</td>
            <td>3-0-0-3</td>
            </tr>
			<tr>
             <td>11</td>
            <td>MA616L Biostatistics (pre-requisite: MA508L)</td>
            <td>3-0-0-3</td>
            </tr>
			<tr>
              <td>12</td>
            <td>MA617L Categorical Data Analysis (pre-requisite: MA508L)</td>
            <td>3-0-0-3</td>
            </tr>
			<tr>
              <td>13</td>
            <td>MA619L Functional Data Analysis (pre-requisite: MA508L)</td>
            <td>3-0-0-3</td>
            </tr>
			<tr>
              <td>14</td>
            <td>MA622L Operations Research</td>
            <td>3-0-0-3</td>
            </tr>
			<tr>
             <td>15</td>
            <td>MA624L Spatio-Temporal Modelling (pre-requisite: MA508L)</td>
            <td>3-0-0-3</td>
            </tr>
			<tr>
             <td>16</td>
            <td>MA625L Statistical Finance (pre-requisite: MA508L)</td>
            <td>3-0-0-3</td>
            </tr>
			<tr>
             <td>17</td>
            <td>MA626L Statistical Simulations and Data Analysis (pre-requisite: MA508L)</td>
            <td>3-0-0-3</td>
            </tr>
			<tr>
             <td>18</td>
            <td>MA628L Statistical Analysis of Network (pre-requisite: MA508L)</td>
            <td>3-0-0-3</td>
            </tr>
			<tr>
             <td>19</td>
            <td>MA629L Statistical Learning: Theory and Applications (pre- requisite: MA508L)</td>
            <td>3-0-0-3</td>
            </tr>
            <tr>
            <td></td>
            <td Rowspan="2"><b>TOTAL CREDITS</b></td>
            
            <td> <b>12</b> </td>
            </tr>

            
            </tbody>
                    </table>`,
        }

        ,

        {
            id: 'headingTwel',
            question: 'Mechanical Engineering - Minor in Additive Manufacturing',
            answer: `<table class="table table-striped table-bordered" style="width:100%; text-align: left;" >   
                     <tbody style="line-height: 2.5;">
            <tr>
            
           		<tr>
            <th Colspan="3">Core Courses</th>
            </tr>
            <tr>
            <th>S.No.</th>
            <th>Course Title</th>
            <th>L-T-P-C</th>
            </tr>
            <tr>
            <td>1</td>
            <td>ME316L CAD-CAM</td>
            <td>3-0-0-3</td>
            </tr>
            <tr>
            <td>2</td>
            <td>ME504L Additive Manufacturing</td>
            <td>3-0-0-3</td>
            </tr>
			 <tr classname='text-center'>
            <th Colspan="3">Elective Courses</th>
            </tr>
            <tr>
            <td>3</td>
            <td>ME3XXL Design for Additive Manufacturing</td>
            <td>2-0-0-2</td>
            </tr>
			<tr>
            <td>4</td>
            <td>ME3XXL Post Processing &amp; Characterization Methods for Additive Manufacturing</td>
            <td>2-0-2-3</td>
            </tr>
            <tr>
              <td>5</td>
            <td>ME403M Mechatronics</td>
            <td class="column2 style3 s">3-0-2-4</td>
            </tr>
            <tr>
             <td>6</td>
            <td>ME520L Mechanics and Control of Robotic Manipulators</td>
            <td>3-0-0-3</td>
            </tr>
            <tr>
          <td>7</td>
            <td>EE603L Robotics and Automation</td>
            <td>3-0-0-3</td>
            </tr>
            <tr>
             <td>8</td>
            <td>ME203M Material Science and Engineering</td>
            <td>3-0-2-4</td>
            </tr>
			<tr>
            <td>9</td>
            <td>ME512L Product Design and Development</td>
            <td>3-0-0-3</td>
            </tr>
			<tr>
             <td>10</td>
            <td>ME502L Finite Element Methods in Engineering Mechanics</td>
            <td>3-0-0-3</td>
            </tr>
			
            <tr>
            <td></td>
            <td Rowspan="2"><b>TOTAL CREDITS</b></td>
            
            <td> <b>12</b> </td>
            </tr>

            
            </tbody>
                    </table>`,
        },
        {
            id: 'headingThie',
            question: 'Mechanical Engineering - Minor in Robotics and Autonomous Systems',
            answer: `<table class="table table-striped table-bordered" style="width:100%; text-align: left;" >   
                     <tbody style="line-height: 2.5;">
            <tr>
            
           		<tr>
            <th Colspan="3">Core Courses</th>
            </tr>
            <tr>
            <th>S.No.</th>
            <th>Course Title</th>
            <th>L-T-P-C</th>
            </tr>
            <tr>
            <td>1</td>
            <td>EE303L Control Engineering or<br />ME308M System Dynamics and Control (only one of the two)</td>
            <td>3-1-0-4<br />3-0-2-4</td>
            </tr>
            <tr>
            <td>2</td>
             <td>ME529L Attitude Estimation and Control</td>
            <td>3-0-0-3</td>
            </tr>
			 <tr classname='text-center'>
            <th Colspan="3">Elective Courses</th>
            </tr>
            
			<tr>
            <td>3</td>
            <td>ME520L Mechanics and Control of Robotic Manipulators</td>
            <td>3-0-0-3</td>
            </tr>
            <tr>
              <td>4</td>
            <td>EE553L Modeling and Control of Autonomous Mobile Robots</td>
            <td>3-0-0-3</td>
            </tr>
            <tr>
             <td>5</td>
             <td>ME538L Introduction to Field and Service Robots</td>
            <td>3-0-0-3</td>
            </tr>
            <tr>
          <td>6</td>
             <td>ME523L Robotic Control Systems</td>
            <td>3-0-0-3</td>
            </tr>
            <tr>
             <td>7</td>
            <td>ME544P Robotics Laboratory</td>
            <td>0-0-3-2</td>
            </tr>
			<tr>
            <td>8</td>
             <td>EE507L Computer Vision</td>
            <td>3-0-0-3</td>
            </tr>
			<tr>
             <td>9</td>
            <td>EE567L Machine Learning for Signal Inference</td>
            <td>3-0-0-3</td>
            </tr>
			<tr>
             <td>10</td>
            <td>EE555L Deep Learning for Computer Vision</td>
            <td>3-0-0-3</td>
            </tr>
			
            <tr>
            <td></td>
            <td Rowspan="2"><b>TOTAL CREDITS</b></td>
            
            <td> <b>12</b> </td>
            </tr>

            
            </tbody>
                    </table>`,
        },

        {
            id: 'headingThie',
            question: 'Mechanical Engineering -  Minor in Space Science and Engineering',
            answer: `<table class="table table-striped table-bordered" style="width:100%; text-align: left;" >   
                     <tbody style="line-height: 2.5;">
            <tr>
            
           		<tr>
            <th Colspan="3">Core Courses</th>
            </tr>
            <tr>
            <th>S.No.</th>
            <th>Course Title</th>
            <th>L-T-P-C</th>
            </tr>
            <tr>
            <td>1</td>
            <td>CH218L  Process Dynamics and Control (Or) <br /> EE308L Control Engineering (Or)<br /> ME312M Linear System Dynamics and Control</td>
            <td>3-1-0-4<br />3-1-0-4<br />3-0-2-4</td>
            </tr>
            <tr>
            <td>2</td>
             <td>ME550L  Orbital Mechanics</td>
            <td>3-0-0-3</td>
            </tr>
			 <tr classname='text-center'>
            <th Colspan="3">Elective Courses</th>
            </tr>
            
			<tr>
            <td>3</td>
            <td>ME545L Introduction to Robotics</td>
            <td>3-0-0-3</td>
            </tr>
            <tr>
              <td>4</td>
            <td>ME547L  Attitude Dynamics and Control</td>
            <td>3-0-0-3</td>
            </tr>
            <tr>
             <td>5</td>
             <td>EE543L RF and Mixed Signal Design</td>
            <td>3-0-0-3</td>
            </tr>
            <tr>
          <td>6</td>
             <td>EE550L RF Transceiver Design</td>
            <td>3-0-0-3</td>
            </tr>
            <tr>
             <td>7</td>
            <td>EE548L  Antenna Theory and Design</td>
            <td>0-0-3-2</td>
            </tr>
			<tr>
            <td>8</td>
             <td>CE525M  GIS and Remote Sensing</td>
            <td>1-0-3-3</td>
            </tr>
			<tr>
             <td>9</td>
            <td>PH202L  Applied Optics</td>
            <td>3-1-0-4</td>
            </tr>
			<tr>
            <td>10</td>
            <td>PH517L  Introduction to Astronomy and Astrophysics</td>
            <td>3-0-0-3</td>
            </tr>
            <td>11</td>
            <td>PH518L  General Relativity and Cosmology</td>
            <td>3-0-0-3</td>
            </tr>
			
            <tr>
            <td></td>
            <td Rowspan="2"><b>TOTAL CREDITS</b></td>
            
            <td> <b>12</b> </td>
            </tr>

            
            </tbody>
                    </table>`,
        },
        {
            id: 'headingFour',
            question: 'Physics - Minor in Quantum Technologies',
            answer: `<table class="table table-striped table-bordered" style="width:100%; text-align: left;" >   
                     <tbody style="line-height: 2.5;">
            <tr>
            
           		<tr>
            <th Colspan="3">Core Courses</th>
            </tr>
            <tr>
            <th>S.No.</th>
            <th>Course Title</th>
            <th>L-T-P-C</th>
            </tr>
            <tr>
            <td>1</td>
            <td>PH510L Quantum Mechanics I </td>
            <td>3-1-0-4</td>
            </tr>
            <tr>
            <td>2</td>
             <td>PH519P Quantum Technology Laboratory</td>
            <td>0-0-3-2</td>
            </tr>
			 <tr classname='text-center'>
            <th Colspan="3">Elective Courses</th>
            </tr>
            
			<tr>
            <td>3</td>
            <td>PH513L Introduction to Quantum Entanglement and Quantum Computing</td>
            <td>3-0-0-3</td>
            </tr>
            <tr>
              <td>4</td>
            <td>PH515L Basics of Quantum Computation</td>
            <td>3-0-0-3</td>
            </tr>
            <tr>
             <td>5</td>
             <td>CS505L Computational Complexity Theory</td>
            <td>3-0-0-3</td>
            </tr>
            <tr>
          <td>6</td>
             <td>CS544L Quantum Computer Systems</td>
            <td>3-0-0-3</td>
            </tr>
            <tr>
             <td>7</td>
            <td>CS549L Introduction to Quantum Algorithms</td>
            <td>0-0-3-2</td>
            </tr>
			<tr>
            <td>8</td>
             <td>EE563L Quantum Information Theory</td>
            <td>3-0-0-3</td>
            </tr>
			<tr>
             <td>9</td>
            <td>EE511L Information Theory and Coding</td>
            <td>3-0-0-3</td>
            </tr>
			<tr>
             <td>10</td>
            <td>EE518L Introduction to Integrated Photonics</td>
            <td>3-0-0-3</td>
            </tr>
            <tr>
             <td>11</td>
            <td>EE561L Fiber Optic Systems</td>
            <td>3-0-0-3</td>
            </tr>
            <tr>
             <td>12</td>
            <td>PH606L Fundamentals of Laser Physics</td>
            <td>3-0-0-3</td>
            </tr>
            <tr>
             <td>13</td>
            <td>PH602L Classical and Quantum Optics</td>
            <td>3-0-0-3</td>
            </tr>
            <tr>
             <td>14</td>
            <td>EE578L Introduction to Spintronics</td>
            <td>3-0-0-3</td>
            </tr>
            <tr>
             <td>15</td>
            <td>PH607L Magnetism and Superconductivity</td>
            <td>3-0-0-3</td>
            </tr>
            <tr>
             <td>16</td>
            <td>PH505L Condensed Matter Physics</td>
            <td>3-1-0-4</td>
            </tr>
            <tr>
             <td>17</td>
            <td>EE524L Nanoelectronic Devices</td>
            <td>3-0-0-3</td>
            </tr>
            <tr>
             <td>18</td>
            <td>EE542L Physics and Modeling of Semiconductor Devices</td>
            <td>3-1-0-4</td>
            </tr>
			
            <tr>
            <td></td>
            <td Rowspan="2"><b>TOTAL CREDITS</b></td>
            
            <td> <b>12</b> </td>
            </tr>

            
            </tbody>
                    </table>`,
        }



    ];
    return (
        <>
            <Header />
            <Breadcrumb title="Home" subtitle="Academic" />
            <section className="project-detail">

                <Container>
                    <Row>

                        <div className="c-heading mb-5">
                            <h1>Minors</h1>
                        </div>
                       


                        <div className="col-lg-4 col-md-4  c-left custom-padding-color wow fadeInUp animated" data-animation="fadeInUp" data-delay=".4s" >
                            <Academicleft activeIndex={15} />
                        </div>


                        <div className="col-lg-8 col-md-8 c-right text-center wow fadeInUp animated" data-animation="fadeInUp" data-delay=".4s" >
                        <div className="caboutus">
                        <h4 className="mb-15 text-left">Board Guidelines for Minors in B.Tech Program:</h4>
                        <ul className='ms-3 c-lineheight2dot5 iarrow' >
                        <li><i className="fal fa-arrow-alt-circle-right me-3 c-link" /> Fulfilling the programme credit requirements as per the Institute Ordinances & Regulations is mandatory for earning the Major degree. </li>
                        <li><i className="fal fa-arrow-alt-circle-right me-3 c-link" /> The Minor will be awarded only if a minimum of 12 credits are completed from the approved minors course list.</li>
                        <li><i className="fal fa-arrow-alt-circle-right me-3 c-link" /> Out of 12 credits, core courses should be a minimum of 6 credits and elective courses should also be a minimum of 6 credits. The elective courses should be taken from the basket of courses given as electives in that Minor.</li>
                        </ul>
                        </div><br />
                            <div className="faq-wrap pl-30 wow fadeInUp animated" data-animation="fadeInUp" data-delay=".4s">
                                <div className="accordion" id="accordionExample">
                                    {faqData.map((item, index) => (
                                        <div className="card" key={index}>
                                            <div className="card-header" id={item.id}>
                                                <h2 className="mb-0">
                                                    <button className={`faq-btn${activeIndex === index ? '' : ' collapsed'}`}
                                                        type="button" data-bs-toggle="collapse"
                                                        data-bs-target={`#collapse${index}`}
                                                        onClick={() => handleToggle(index)} >
                                                        {item.question}
                                                    </button>
                                                </h2>
                                            </div>
                                            <div id={`collapse${index}`}
                                                className={`collapse${activeIndex === index ? ' show' : ''} lower-content`}
                                                data-bs-parent="#accordionExample">
                                                <div dangerouslySetInnerHTML={{ __html: item.answer }} className="card-body"></div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>

                    </Row>
                </Container>


            </section>
        </>
    );
}

export default Main;